__webpack_require__.p = "/know-your-legend/";